import { ReactNode, createContext, useContext, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

const FlowIdContext = createContext<string | undefined>(undefined);

type FlowIdProviderProps = {
  isOpen?: boolean;
  children?: ReactNode;
};

export const FlowIdProvider = ({ isOpen, children }: FlowIdProviderProps) => {
  const flowId = useMemo(() => uuidv4(), [isOpen]);

  return (
    <FlowIdContext.Provider value={flowId}>{children}</FlowIdContext.Provider>
  );
};

export function useFlowId() {
  const contextFlowId = useContext(FlowIdContext);
  return useMemo(() => contextFlowId ?? uuidv4(), [contextFlowId]);
}
